import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

let appElement = document.getElementById("app");
if (appElement) {
    Vue.use(Vuex);
}

const vuexPersist = new VuexPersist({
    key: "app",
    storage: sessionStorage,
});

let initialState = {
    uuid: null,
    job: null,

    stepPersonalValid: false,
    stepContactValid: false,
    stepUploadValid: false,

    stepPersonalData: {},
    stepContactData: {},
    stepUploadData: {
        fileList: [],
    },
};

const state = Vue.util.extend({}, initialState);

export default new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state: state,
    mutations: {
        setPersonalData(state, data) {
            Vue.set(state, "stepPersonalData", data);
        },
        updateStepPersonalData(state, payload) {
            Vue.set(state.stepPersonalData, payload.field, payload.value);
        },
        setContactData(state, data) {
            Vue.set(state, "stepContactData", data);
        },
        setUploadData(state, data) {
            Vue.set(state, "stepUploadData", data);
        },
        setUniqueId(state, data) {
            Vue.set(state, "uuid", data);
        },
        setJob(state, data) {
            Vue.set(state, "job", data);
        },
        setPersonalValid(state, data) {
            Vue.set(state, "stepPersonalValid", data);
        },
        setContactValid(state, data) {
            Vue.set(state, "stepContactValid", data);
        },
        setUploadValid(state, data) {
            Vue.set(state, "stepUploadValid", data);
        },
        clear(state) {
            for (let key in state) {
                Vue.set(state, key, initialState[key]);
            }
        },
    },
    actions: {},
});
